export default defineNuxtRouteMiddleware((to, from) => {
    if (to.path === '/promocao/ads' || to.path === '/promocao/ads/') {
        return navigateTo({
            path: '/promocao/ads/escolha-sua-cidade',
            query: {...to.query},
        })
    }
})
